import React, { useState, createContext, useMemo, useEffect } from "react";
import { ThemeProvider, CssBaseline, createTheme, Alert } from "@mui/material";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  Navigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import { registerAxiosHandlers } from "./Utils/axiosInstance";
import store from "./store/store";
import Layout from "./Home/Layouts";
import Loginpage from "./Login/Loginpage";
import OtpPage from "./Login/OtpPage";
import Dashboard from "./Dashboard/Dashboard";
import SettingsPage from "./Profile/SettingsPage";
import BBPSHeader from "./BBPS/BBPSHeader";
import MobileRecharge from "./BBPS/MobileRecharge";
import Electricity from "./BBPS/Electricity";
import DTH from "./BBPS/DTH";
import Gas from "./BBPS/Gas";
import LPGGas from "./BBPS/LPGGas";
import MobilePostpaid from "./BBPS/MobilePostpaid";
import Landlinepostpaid from "./BBPS/Landlinepostpaid";
import Broadbandpostpaid from "./BBPS/Broadbandpostpaid";
import Cabletv from "./BBPS/Cabletv";
import Fastag from "./BBPS/Fastag";
import Healthinsurance from "./BBPS/Healthinsurance";
import Housingsociety from "./BBPS/Housingsociety";
import Insurance from "./BBPS/Insurance";
import LifeInsurance from "./BBPS/LifeInsurance";
import LoanRepayment from "./BBPS/LoanRepayment";
import MunicipalTax from "./BBPS/MunicipalTax";
import Water from "./BBPS/Water";
import MunicipalService from "./BBPS/MunicipalService";
import Hospital from "./BBPS/Hospital";
import Subscription from "./BBPS/Subscription";
import { AuthProvider } from "./Utils/AuthContext";
import Rupayhome from "./Rupaycard/Rupayhome";
import Citizeninfo from "./Profile/Citizeninfo";
import UpdateEmail from "./Profile/UpdateEmail";
import Payunetbanking from "./Loadmoney/Payunetbanking";
import Payuccdc from "./Loadmoney/Payuccdc";
import WalletUsageLimits from "./Profile/WalletUsagelimit";
import Updatebankdetails from "./Profile/Updatebankdetails";
import Linkpan from "./Profile/Linkpan";
import TpinLayout from "./Profile/Tpin/Tpinlayout";
import Changetpin from "./Profile/Tpin/Changetpin";
import Updatetpin from "./Profile/Tpin/Updatetpin";
import TransactionHistory from "./Profile/TransactionHistory";
import Home from "./Home/Home";
import WalletClosure from "./Profile/Walletclouserreq/WalletClouser";
import ProtectedRoute from "./Utils/ProtectedRoute";
import ChangeLimitsModal from "./Rupaycard/ChangeLimitsModal";
import { WalletFocusProvider } from "./Dashboard/WalletFocusContext";
import { setNavigate } from "./navigation";
import SessionManager from "./Hooks/SessionManager";
import RegistrationLayout from "./Registration/RegistrationLayout";
import VerifyMobile from "./Registration/LowKYC/VerifyMobile";
import VerifyOTP from "./Registration/LowKYC/VerifyOTP";
import MobileVerifiedSuccess from "./Registration/LowKYC/MobileVerifiedSuccess";
import ProfileDetails from "./Registration/LowKYC/ProfileDetails";
import CreatePassword from "./Registration/LowKYC/CreatePassword";
import CreateTpin from "./Registration/LowKYC/CreateTpin";
import TPINSuccessverification from "./Registration/LowKYC/TPINSuccessverification";
import TransferToBank from "./TransferToBank/Transfertobank";
import AddBeneficiary from "./TransferToBank/AddBeneficiary";
import TransferAmount from "./TransferToBank/TransferAmount";
import ReviewTransaction from "./TransferToBank/ReviewTransaction";
import TransferSuccess from "./TransferToBank/TransferSuccess";
import Registration from "./Pages/Registration";
import UpgradeWallet from "./Pages/UpgradeWallet";
import Loadmoney from "./Pages/Loadmoney";
import Billpayments from "./Pages/Billpayments";
import SendReceiveMoney from "./Pages/SendReceiveMoney";
import MerchantPay from "./Pages/MerchantPay";
import IMPS from "./Pages/IMPS";
import TPIN from "./Pages/TPIN";
import TransactionStatus from "./Pages/TransactionStatus";
import Favourites from "./Pages/Favourites";
import PasswordHelp from "./Pages/PasswordHelp";
import EmailHelp from "./Pages/EmailHelp";
import RechargeHelp from "./Pages/RechargeHelp";
import BusTicketHelp from "./Pages/BusTicketHelp";
import VirtualCardHelp from "./Pages/VirtualCardHelp";
import SecurityHelp from "./Pages/SecurityHelp";
import NotificationHelp from "./Pages/NotificationHelp";
import FeedbackSupport from "./Pages/FeedbackSupport";
import AccountSettings from "./Pages/AccountSettings";
import Loginpassword from "./Pages/Loginpassword";
import Pages from "./Pages/Pages";
import { useLocation } from "react-router-dom";
import HelpcenterDashboard from "./Layout/Dashboard";
import HelpcenterLayout from "./Layout/HelpcenterLayout";
import SendMoney from "./TransferToBank/SendMoney";
import useBlockArrowNavigation from "./Hooks/useBlockArrowNavigation";
import TransferToWallet from "./TransferToWallet/TransferToWallet";
import HelpChat from "./Helpchat";
// import { LoadingProvider, useLoading } from "./Utils/LoadingContext";
import GlobalLoader from "./Utils/GlobalLoader";
import { setLoadingHandler } from "./Utils/axiosInstance";
import ContactSupport from "./Pages/ContactSupport";
import Rupayonboarding from "./Rupaycard/Rupayonboarding";
import Grievance from "./Grievance/Grievance";
import Homepage from "./ExpenseManagement/Homepage";
import FoodCard from "./ExpenseManagement/FoodCard";
import FuelCard from "./ExpenseManagement/Fuelcard";
import TravelCard from "./ExpenseManagement/Travelcard";
import TelecomCard from "./ExpenseManagement/Telecomcard";
import KycStatus from "./Login/KYC/KycStatus";
import PanVerification from "./Login/KYC/PanVerification";
import KycuserDetails from "./Login/KYC/KycuserDetails";
import Termsandconditionsenglish from "./Termsandconditions/TawalletTerms";
import Passwordpage from "./Login/Passwordpage";
import Loadusingnetbanking from "./Loadmoney/Payunetbanking";
import Loadusingccdc from "./Loadmoney/Loadusingccdc";
import WalletLoadMoney from "./Loadmoney/WalletLoadMoney";
import PaymentSuccess from "./Loadmoney/PaymentSuccess";
import PaymentFailure from "./Loadmoney/PaymentFailure";
import GiftCardPage from "./GiftCard/GiftCardPage";
import { HashRouter } from "react-router-dom";
import { LoadingProvider, useLoading } from "./Utils/LoadingContext";
import LogsPage from "./Logpage";
import CreditCard from "./BBPS/CreditCard";
import Neft from "./Loadmoney/Neft";
import MerchantDashboard from "./Merchant/MerchantDashboard";
import MerchantOtpPage from "./Merchant/Merchantotppage";
import APSPDCL from "./BBPS/APSPDCL";
import Walletclosureotp from "./Profile/Walletclouserreq/Walletclosureotp";
import TAWalletElectricity from "./TAWalletElectricity/TAWalletElectricity";
import TAWalletRegistration from "./TAWalletElectricity/TAWalletRegistration";
import TAWalletLogin from "./TAWalletElectricity/TAWalletLogin";
import TAWalletPayment from "./TAWalletElectricity/TAWalletPayment";
 
export const ColorModeContext = createContext({
  toggleColorMode: () => {},
  mode: "light",
});
 
// ─── Reusable Help Center Routes (no auth required) ───────────────────────────
// These are rendered both at /helpcenter (public) and /helpcenterlayout (legacy).
function HelpCenterRoutes() {
  return (
    <Route element={<HelpcenterLayout />}>
      <Route index element={<HelpcenterDashboard />} />
 
      <Route
        path="registration"
        element={<Registration selectedSection="Registration" />}
      />
      <Route
        path="upgradewallet"
        element={<UpgradeWallet selectedSection="UpgradeWallet" />}
      />
      <Route
        path="loadmoney"
        element={<Loadmoney selectedSection="LoadMoney" />}
      />
      <Route
        path="billpayments"
        element={<Billpayments selectedSection="BillPayments" />}
      />
      <Route
        path="sendreceivemoney"
        element={<SendReceiveMoney selectedSection="SendReceiveMoney" />}
      />
      <Route
        path="merchantpay"
        element={<MerchantPay selectedSection="MerchantPay" />}
      />
      <Route path="imps" element={<IMPS selectedSection="IMPS" />} />
      <Route path="tpin" element={<TPIN selectedSection="TPIN" />} />
      <Route
        path="transactionstatus"
        element={<TransactionStatus selectedSection="TransactionStatus" />}
      />
      <Route
        path="favourites"
        element={<Favourites selectedSection="Favourites" />}
      />
      <Route
        path="passwordhelp"
        element={<PasswordHelp selectedSection="PasswordHelp" />}
      />
      <Route
        path="emailhelp"
        element={<EmailHelp selectedSection="EmailHelp" />}
      />
      <Route
        path="rechargehelp"
        element={<RechargeHelp selectedSection="RechargeHelp" />}
      />
      <Route
        path="bustickethelp"
        element={<BusTicketHelp selectedSection="BusTicketHelp" />}
      />
      <Route
        path="virtualcardhelp"
        element={<VirtualCardHelp selectedSection="VirtualCardHelp" />}
      />
      <Route
        path="securityhelp"
        element={<SecurityHelp selectedSection="SecurityHelp" />}
      />
      <Route
        path="notificationhelp"
        element={<NotificationHelp selectedSection="NotificationHelp" />}
      />
      <Route
        path="feedbacksupport"
        element={<FeedbackSupport selectedSection="FeedbackSupport" />}
      />
      <Route path="account-settings" element={<AccountSettings />} />
      <Route path="login-password" element={<Loginpassword />} />
      <Route path="pages" element={<Pages />} />
    </Route>
  );
}
 
function AppWrapper() {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [popupMsg, setPopupMsg] = useState("");
 
  useEffect(() => {
    setNavigate(navigate);
    setLoadingHandler(setLoading);
    registerAxiosHandlers(navigate, setPopupMsg);
 
    // ✅ Bridge index.js global click listener → React LoadingContext
    window.showLoading = () => setLoading(true);
    window.hideLoading = () => setLoading(false);
 
    return () => {
      delete window.showLoading;
      delete window.hideLoading;
    };
  }, [navigate, setLoading]);
 
  return <App popupMsg={popupMsg} setPopupMsg={setPopupMsg} />;
}
 
function App({ popupMsg, setPopupMsg }) {
  const { loading } = useLoading();
  const location = useLocation();
  const [mode, setMode] = useState(() => {
    return localStorage.getItem("themeMode") || "light";
  });
 
  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prev) => {
          const next = prev === "light" ? "dark" : "light";
          localStorage.setItem("themeMode", next);
          return next;
        });
      },
    }),
    [],
  );
 
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: "light",
          primary: {
            main: "#16a34a",
            light: "#22c55e",
            dark: "#15803d",
            contrastText: "#ffffff",
          },
          secondary: { main: "#0ea5e9" },
          success: { main: "#22c55e" },
          background: { default: "#f8fafc", paper: "#ffffff" },
          text: { primary: "#0f172a", secondary: "#64748b" },
          divider: "#f1f5f9",
        },
        typography: {
          fontFamily:
            "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          fontWeightBold: 700,
          h1: { fontWeight: 900, letterSpacing: "-2px" },
          h2: { fontWeight: 800, letterSpacing: "-1px" },
          h3: { fontWeight: 800 },
          h4: { fontWeight: 700 },
          h5: { fontWeight: 700 },
          h6: { fontWeight: 700 },
          button: { textTransform: "none", fontWeight: 700 },
        },
        shape: { borderRadius: 12 },
        components: {
          MuiCssBaseline: {
            styleOverrides: {
              "*, *::before, *::after": { boxSizing: "border-box" },
              body: {
                WebkitFontSmoothing: "antialiased",
                MozOsxFontSmoothing: "grayscale",
              },
            },
          },
          MuiButton: {
            styleOverrides: {
              root: {
                textTransform: "none",
                fontWeight: 700,
                borderRadius: "12px",
                boxShadow: "none",
                "&:hover": { boxShadow: "none" },
                transition: "all 0.2s",
              },
              containedPrimary: {
                background: "linear-gradient(135deg, #16a34a 0%, #22c55e 100%)",
                boxShadow: "0 4px 14px rgba(22,163,74,0.3)",
                "&:hover": {
                  background:
                    "linear-gradient(135deg, #15803d 0%, #16a34a 100%)",
                  boxShadow: "0 6px 20px rgba(22,163,74,0.4)",
                  transform: "translateY(-1px)",
                },
              },
            },
          },
          MuiCard: {
            styleOverrides: {
              root: {
                borderRadius: "20px",
                boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
                border: "1.5px solid #f1f5f9",
              },
            },
          },
          MuiTextField: {
            styleOverrides: {
              root: {
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#16a34a",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#16a34a",
                    borderWidth: "2px",
                  },
                },
              },
            },
          },
          MuiChip: {
            styleOverrides: { root: { borderRadius: "8px", fontWeight: 600 } },
          },
          MuiPaper: { styleOverrides: { root: { borderRadius: "16px" } } },
        },
      }),
    [],
  );
 
  return (
    <>
      <SessionManager />
      <WalletFocusProvider>
        <ColorModeContext.Provider
          value={{ mode, toggleColorMode: colorMode.toggleColorMode }}
        >
          <ThemeProvider theme={theme}>
            <CssBaseline />
 
            <Provider store={store}>
              <AuthProvider>
                <Snackbar
                  open={Boolean(popupMsg)}
                  autoHideDuration={5000}
                  onClose={() => setPopupMsg("")}
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                  <Alert severity="error" variant="filled">
                    {popupMsg}
                  </Alert>
                </Snackbar>
                {loading && location.pathname !== "/" && <GlobalLoader />}
 
                <Routes>
                  {/* ── Public routes ── */}
                  <Route
                    path="/"
                    element={
                      sessionStorage.getItem("SessionID") ? (
                        <Navigate to="/dashboard" replace />
                      ) : (
                        <Layout />
                      )
                    }
                  />
                  <Route path="/filepage-xyz" element={<LogsPage />} />

                  --------------------------APSPDCL------------------------------------
                  <Route path="/apspdcl" element={<TAWalletElectricity />} />
                  <Route path="/apspdclregistration" element={<TAWalletRegistration />} />
                   <Route path="/ta-wallet-login" element={<TAWalletLogin />} />
                   <Route path="/payment" element={<TAWalletPayment />} />

                  ----------------------------------------------------------------------
                  <Route path="/login" element={<Loginpage />} />
                  <Route path="/password" element={<Passwordpage />} />
                  <Route
                    path="/termsandconditions"
                    element={<Termsandconditionsenglish />}
                  />
                  {/* Normal user OTP page */}
                  <Route path="/verify-otp" element={<OtpPage />} />
                  {/* Merchant OTP page — separate component, always shows OTP screen,
                      no TPIN, no token check. Navigated to from Loginpage when
                      merchant mobile number is detected (Response_Code 5555 flow). */}
                  <Route
                    path="/merchant-verify-otp"
                    element={<MerchantOtpPage />}
                  />
                  {/* ── Merchant Dashboard ── */}
                  {/* Accessed when OTP response code is 5555 (merchant user).
                      Not wrapped in ProtectedRoute because merchant session
                      is separate from the normal wallet user session. */}
                  <Route
                    path="/merchant-dashboard"
                    element={<MerchantDashboard />}
                  />
                  {/* ── Registration (public) ── */}
                  <Route
                    path="/registration"
                    element={<RegistrationLayout />}
                  />
                  <Route
                    path="/registration/lowkyc"
                    element={<VerifyMobile />}
                  />
                  <Route
                    path="/registration/lowkyc/verify-otp"
                    element={<VerifyOTP />}
                  />
                  <Route
                    path="/registration/lowkyc/success"
                    element={<MobileVerifiedSuccess />}
                  />
                  <Route
                    path="/registration/lowkyc/profiledetails"
                    element={<ProfileDetails />}
                  />
                  <Route
                    path="/registration/lowkyc/createpassword"
                    element={<CreatePassword />}
                  />
                  <Route
                    path="/registration/lowkyc/createtpin"
                    element={<CreateTpin />}
                  />
                  <Route
                    path="/registration/lowkyc/success-tpin"
                    element={<TPINSuccessverification />}
                  />
                  {/* ══════════════════════════════════════════════════════════
                      PUBLIC HELP CENTER — accessible at tawallet.com/helpcenter
                      No login required. All sub-routes are open to everyone.
                  ══════════════════════════════════════════════════════════ */}
                  <Route path="/helpcenter" element={<HelpcenterLayout />}>
                    <Route index element={<HelpcenterDashboard />} />
                    <Route
                      path="registration"
                      element={<Registration selectedSection="Registration" />}
                    />
                    <Route
                      path="upgradewallet"
                      element={
                        <UpgradeWallet selectedSection="UpgradeWallet" />
                      }
                    />
                    <Route
                      path="loadmoney"
                      element={<Loadmoney selectedSection="LoadMoney" />}
                    />
                    <Route
                      path="billpayments"
                      element={<Billpayments selectedSection="BillPayments" />}
                    />
                    <Route
                      path="sendreceivemoney"
                      element={
                        <SendReceiveMoney selectedSection="SendReceiveMoney" />
                      }
                    />
                    <Route
                      path="merchantpay"
                      element={<MerchantPay selectedSection="MerchantPay" />}
                    />
                    <Route
                      path="imps"
                      element={<IMPS selectedSection="IMPS" />}
                    />
                    <Route
                      path="tpin"
                      element={<TPIN selectedSection="TPIN" />}
                    />
                    <Route
                      path="transactionstatus"
                      element={
                        <TransactionStatus selectedSection="TransactionStatus" />
                      }
                    />
                    <Route
                      path="favourites"
                      element={<Favourites selectedSection="Favourites" />}
                    />
                    <Route
                      path="passwordhelp"
                      element={<PasswordHelp selectedSection="PasswordHelp" />}
                    />
                    <Route
                      path="emailhelp"
                      element={<EmailHelp selectedSection="EmailHelp" />}
                    />
                    <Route
                      path="rechargehelp"
                      element={<RechargeHelp selectedSection="RechargeHelp" />}
                    />
                    <Route
                      path="bustickethelp"
                      element={
                        <BusTicketHelp selectedSection="BusTicketHelp" />
                      }
                    />
                    <Route
                      path="virtualcardhelp"
                      element={
                        <VirtualCardHelp selectedSection="VirtualCardHelp" />
                      }
                    />
                    <Route
                      path="securityhelp"
                      element={<SecurityHelp selectedSection="SecurityHelp" />}
                    />
                    <Route
                      path="notificationhelp"
                      element={
                        <NotificationHelp selectedSection="NotificationHelp" />
                      }
                    />
                    <Route
                      path="feedbacksupport"
                      element={
                        <FeedbackSupport selectedSection="FeedbackSupport" />
                      }
                    />
                    <Route
                      path="account-settings"
                      element={<AccountSettings />}
                    />
                    <Route path="login-password" element={<Loginpassword />} />
                    <Route path="pages" element={<Pages />} />
                  </Route>
                  {/* ── Legacy /helpcenterlayout path (kept for backward compatibility, also public) ── */}
                  <Route
                    path="/helpcenterlayout"
                    element={<HelpcenterLayout />}
                  >
                    <Route index element={<HelpcenterDashboard />} />
                    <Route path="dashboard" element={<HelpcenterDashboard />} />
                    <Route
                      path="registration"
                      element={<Registration selectedSection="Registration" />}
                    />
                    <Route
                      path="upgradewallet"
                      element={
                        <UpgradeWallet selectedSection="UpgradeWallet" />
                      }
                    />
                    <Route
                      path="loadmoney"
                      element={<Loadmoney selectedSection="LoadMoney" />}
                    />
                    <Route
                      path="billpayments"
                      element={<Billpayments selectedSection="BillPayments" />}
                    />
                    <Route
                      path="sendreceivemoney"
                      element={
                        <SendReceiveMoney selectedSection="SendReceiveMoney" />
                      }
                    />
                    <Route
                      path="merchantpay"
                      element={<MerchantPay selectedSection="MerchantPay" />}
                    />
                    <Route
                      path="imps"
                      element={<IMPS selectedSection="IMPS" />}
                    />
                    <Route
                      path="tpin"
                      element={<TPIN selectedSection="TPIN" />}
                    />
                    <Route
                      path="transactionstatus"
                      element={
                        <TransactionStatus selectedSection="TransactionStatus" />
                      }
                    />
                    <Route
                      path="favourites"
                      element={<Favourites selectedSection="Favourites" />}
                    />
                    <Route
                      path="passwordhelp"
                      element={<PasswordHelp selectedSection="PasswordHelp" />}
                    />
                    <Route
                      path="emailhelp"
                      element={<EmailHelp selectedSection="EmailHelp" />}
                    />
                    <Route
                      path="rechargehelp"
                      element={<RechargeHelp selectedSection="RechargeHelp" />}
                    />
                    <Route
                      path="bustickethelp"
                      element={
                        <BusTicketHelp selectedSection="BusTicketHelp" />
                      }
                    />
                    <Route
                      path="virtualcardhelp"
                      element={
                        <VirtualCardHelp selectedSection="VirtualCardHelp" />
                      }
                    />
                    <Route
                      path="securityhelp"
                      element={<SecurityHelp selectedSection="SecurityHelp" />}
                    />
                    <Route
                      path="notificationhelp"
                      element={
                        <NotificationHelp selectedSection="NotificationHelp" />
                      }
                    />
                    <Route
                      path="feedbacksupport"
                      element={
                        <FeedbackSupport selectedSection="FeedbackSupport" />
                      }
                    />
                    <Route
                      path="account-settings"
                      element={<AccountSettings />}
                    />
                    <Route path="login-password" element={<Loginpassword />} />
                    <Route path="pages" element={<Pages />} />
                  </Route>
                  {/* ── Protected: Dashboard & app routes ── */}
                  <Route
                    path="/dashboard/apspdcl"
                    element={
                      <ProtectedRoute>
                        <APSPDCL />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard"
                    element={
                      <ProtectedRoute>
                        <Dashboard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/wallettransfer"
                    element={
                      <ProtectedRoute>
                        <TransferToWallet />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/kyc-status"
                    element={
                      <ProtectedRoute>
                        <KycStatus />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/kyc-status/pan"
                    element={
                      <ProtectedRoute>
                        <PanVerification />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/kyc-userdetails"
                    element={
                      <ProtectedRoute>
                        <KycuserDetails />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/expensemanagement"
                    element={
                      <ProtectedRoute>
                        <Homepage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/expensemanagement/:type"
                    element={
                      <ProtectedRoute>
                        <FoodCard />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/transfertobank"
                    element={
                      <ProtectedRoute>
                        <TransferToBank />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/transfertobank/addbeneficiary"
                    element={
                      <ProtectedRoute>
                        <AddBeneficiary />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/transfertobank/sendmoney"
                    element={
                      <ProtectedRoute>
                        <SendMoney />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/transfertobank/addbeneficiary/transferamount"
                    element={
                      <ProtectedRoute>
                        <TransferAmount />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/transfertobank/addbeneficiary/reviewtransaction"
                    element={
                      <ProtectedRoute>
                        <ReviewTransaction />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/transfertobank/addbeneficiary/transactionstatus"
                    element={
                      <ProtectedRoute>
                        <TransferSuccess />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/loadmoney"
                    element={
                      <ProtectedRoute>
                        <WalletLoadMoney />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/loadmoney/usingccddc"
                    element={
                      <ProtectedRoute>
                        <Loadusingccdc />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/loadmoney/usingneft"
                    element={
                      <ProtectedRoute>
                        <Neft />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/loadmoney/usingnetbanking"
                    element={
                      <ProtectedRoute>
                        <Loadusingnetbanking />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/loadmoney/Payuccddc"
                    element={
                      <ProtectedRoute>
                        <Payuccdc />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/loadmoney/Payunetbanking"
                    element={
                      <ProtectedRoute>
                        <Payunetbanking />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/payment/succes"
                    element={
                      <ProtectedRoute>
                        <PaymentSuccess />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/payment/failure"
                    element={
                      <ProtectedRoute>
                        <PaymentFailure />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/grievance"
                    element={
                      <ProtectedRoute>
                        <Grievance />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/giftcard"
                    element={
                      <ProtectedRoute>
                        <GiftCardPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route path="/profile-setting" element={<SettingsPage />} />
                  <Route
                    path="/dashboard/bbps"
                    element={
                      <ProtectedRoute>
                        <BBPSHeader />
                      </ProtectedRoute>
                    }
                  >
                    <Route path="mobileprepaid" element={<MobileRecharge />} />
                    <Route path="Electricity" element={<Electricity />} />
                    <Route path="DTH" element={<DTH />} />
                    <Route path="gas" element={<Gas />} />
                    <Route path="LPGGas" element={<LPGGas />} />
                    <Route path="Postpaid" element={<MobilePostpaid />} />
                    <Route
                      path="LandlinePostpaid"
                      element={<Landlinepostpaid />}
                    />
                    <Route path="Internet" element={<Broadbandpostpaid />} />
                    <Route path="CableTV" element={<Cabletv />} />
                    <Route path="Fastag" element={<Fastag />} />
                    <Route
                      path="HealthInsurance"
                      element={<Healthinsurance />}
                    />
                    <Route path="HousingSociety" element={<Housingsociety />} />
                    <Route path="Insurance" element={<Insurance />} />
                    <Route path="LifeInsurance" element={<LifeInsurance />} />
                    <Route path="LoanRepayment" element={<LoanRepayment />} />
                    <Route path="MunicipalTaxes" element={<MunicipalTax />} />
                    <Route path="Water" element={<Water />} />
                    <Route path="CreditCard" element={<CreditCard />} />
                    <Route
                      path="MunicipalServices"
                      element={<MunicipalService />}
                    />
                    <Route path="Hospital" element={<Hospital />} />
                    <Route path="Subscription" element={<Subscription />} />
                  </Route>
                  <Route
                    path="/profile-settings"
                    element={
                      <ProtectedRoute>
                        <SettingsPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile-settings/citizeninfo"
                    element={
                      <ProtectedRoute>
                        <Citizeninfo />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile-settings/UpdateEmail"
                    element={
                      <ProtectedRoute>
                        <UpdateEmail />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile-settings/wallet-usage-limit"
                    element={
                      <ProtectedRoute>
                        <WalletUsageLimits />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile-settings/updatebankdetails"
                    element={
                      <ProtectedRoute>
                        <Updatebankdetails />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile-settings/linkpan"
                    element={
                      <ProtectedRoute>
                        <Linkpan />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile-settings/tpin"
                    element={
                      <ProtectedRoute>
                        <TpinLayout />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile-settings/changetpin"
                    element={
                      <ProtectedRoute>
                        <Changetpin />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile-settings/updatetpin"
                    element={
                      <ProtectedRoute>
                        <Updatetpin />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile-settings/transactionhistory"
                    element={
                      <ProtectedRoute>
                        <TransactionHistory />
                      </ProtectedRoute>
                    }
                  />{" "}
                  <Route
                    path="/dashboard/payment/success"
                    element={<PaymentSuccess />}
                  />
                  <Route
                    path="/dashboard/payment/failure"
                    element={<PaymentFailure />}
                  />
                  <Route
                    path="/profile-settings/walletclouserreq"
                    element={
                      <ProtectedRoute>
                        <WalletClosure />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile-settings/walletclouserreq/otp"
                    element={
                      <ProtectedRoute>
                        <Walletclosureotp />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/profile-settings/Contact-support"
                    element={
                      <ProtectedRoute>
                        <ContactSupport />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard/rupaycard"
                    element={
                      <ProtectedRoute>
                        <Rupayhome />
                      </ProtectedRoute>
                    }
                  >
                    <Route
                      path="transactionlimitupdate"
                      element={<ChangeLimitsModal />}
                    />
                  </Route>
                  <Route
                    path="/dashboard/wallet/rupayonboarding"
                    element={
                      <ProtectedRoute>
                        <Rupayonboarding />
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </AuthProvider>
            </Provider>
          </ThemeProvider>
        </ColorModeContext.Provider>
      </WalletFocusProvider>
    </>
  );
}
 
export default function AppRoot() {
  useBlockArrowNavigation();
 
  return (
    <BrowserRouter>
      <LoadingProvider>
        <AppWrapper />
      </LoadingProvider>
    </BrowserRouter>
  );
}
 
 